import React from "react";
import "./LegalPages.css";

function RefundPolicyPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Refund Policy</h1>
        <p className="legal-subtitle">Last updated: March 21, 2026</p>

        <section className="legal-section">
          <h2>Refund Terms</h2>
          <p>
            JAPAKING does not offer refunds for payments made towards software subscription fees
            and software development fees.
          </p>
        </section>

        <section className="legal-section">
          <h2>Digital Service Clarification</h2>
          <p>
            Since JAPAKING provides instant digital access to premium learning content after
            successful payment, all purchases are treated as final unless required by applicable
            law.
          </p>
        </section>

        <section className="legal-section">
          <h2>Billing Issues</h2>
          <p>
            If you face duplicate charge, failed payment with debit, or payment verification issue,
            contact us with transaction details at ishan@erishsolutions.com.
          </p>
        </section>

        <div className="legal-footer-note">
          Support Email: ishan@erishsolutions.com
        </div>
      </div>
    </div>
  );
}

export default RefundPolicyPage;
